/* istanbul ignore file */
import { useEffect } from 'react';
import googleAnalytics from 'react-ga';
import { useLocation } from 'react-router-dom';

// Auth hand-off parameters must not reach analytics.
const SENSITIVE_QUERY_PARAMS = ['token', 'code', 'state', 'ssid'];

const withoutSensitiveParams = (search: string) => {
  const params = new URLSearchParams(search);
  SENSITIVE_QUERY_PARAMS.forEach(param => params.delete(param));
  const query = params.toString();
  return query ? `?${query}` : '';
};

const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

    if (googleAnalyticsId) {
      googleAnalytics.initialize(googleAnalyticsId);
    }
  }, []);

  useEffect(() => {
    googleAnalytics.pageview(location.pathname + withoutSensitiveParams(location.search));
  }, [location]);
};

export default useGoogleAnalytics;
